import React from "react";
import Button from "../ui/Button";

const OnboardingLayout = ({
    currentStep,
    totalSteps,
    title,
    subtitle,
    children,
    onBack,
    onContinue,
    isContinueDisabled = false,
    continueLabel = "Continue",
    hideContinue = false,
    preview
}) => {
    // Generate progress dashes
    const progressDashes = [];
    for (let i = 1; i <= totalSteps; i++) {
        progressDashes.push(
            <div
                key={i}
                className={`h-1.5 w-8 rounded-full ${i <= currentStep ? 'bg-[#0044CC]' : 'bg-gray-200'}`}
            ></div>
        );
    }

    return (
        <div className="min-h-screen bg-[#fffcf8] flex flex-col md:flex-row p-6 md:p-12 gap-12">

            {/* Left Side - Form */}
            <div className="flex-1 flex flex-col max-w-2xl">
                {/* Header/Logo */}
                <div className="flex items-center gap-2 text-black font-bold text-xl mb-12">
                    <img src="/logo.png" alt="Braccet" className="w-8 h-8 object-contain" />
                    <span>Braccet</span>
                </div>

                {/* Progress Bar */}
                <div className="flex gap-2 mb-4">
                    {progressDashes}
                </div>
                <p className="text-xs text-gray-500 mb-8 font-medium">{currentStep} of {totalSteps}</p>

                {/* Content */}
                <div className="mb-8">
                    <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 leading-tight">{title}</h1>

                    <div className="bg-[#F0F6FF] rounded-3xl p-8 md:p-12">
                        {subtitle && <p className="text-gray-600 font-medium mb-6">{subtitle}</p>}
                        {children}
                    </div>
                </div>

                {/* Footer Actions */}
                <div className="flex gap-4 mt-auto">
                    <Button variant="secondary" onClick={onBack} className="px-8 !rounded-xl bg-white border-none shadow-sm text-gray-700">Back</Button>
                    {!hideContinue && (
                        <Button
                            variant="primary"
                            onClick={onContinue}
                            className={`px-8 !rounded-xl ${isContinueDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                            disabled={isContinueDisabled}
                        >
                            {continueLabel}
                        </Button>
                    )}
                </div>
            </div>

            {/* Right Side - Phone Preview */}
            <div className="hidden md:flex flex-1 items-center justify-center">
                <div className="relative w-[300px] h-[600px] border-4 border border-blue-200 rounded-[3rem] bg-white shadow-2xl p-4">
                    {/* Phone Screen Placeholder */}
                    <div className="w-full h-full bg-white rounded-[2.5rem] overflow-hidden">
                        {preview}
                    </div>
                </div>
            </div>

        </div>
    );
};

export default OnboardingLayout;
